var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.latestWidget && _vm.latestWidget.category)?_c('div',{class:['latest-posts']},[_c('PostList',{attrs:{"size":_vm.latestWidget.numberOfItems,"category":_vm.latestWidget.category.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }